import type React from 'react';
import { useState } from 'react';
import './styles.css';
import Search from '../../../assets/search.png';

interface Props extends React.ComponentPropsWithoutRef<'input'> {
    label?: string
    number?: boolean
    disabled?: boolean
    fullwidth?: boolean
    showSearchIcon?: boolean
    addonRight?: React.ReactNode
    onIconClick?: () => void
}

const AppInput = ({
    label,
    disabled = false,
    className,
    number,
    fullwidth = false,
    showSearchIcon = false,
    addonRight,
    onIconClick = () => {},
    ...rest
}: Props) => {
    const [isFocused, setIsFocused] = useState(false)

    return (
        <label
            className={`flex flex-col text-left text-sm ${
                isFocused ? 'text-black' : 'text-shark-800'
            } ${!fullwidth ? 'w-full' : 'w-max'}`}
        >
            {label}
            <div
                className={`input relative flex text-base px-3 ${
                    label ? 'mt-1' : ''
                } ${disabled ? 'disabled' : ''} ${
                    !fullwidth ? '!w-full' : ''
                } ${isFocused ? 'focused' : ''}`}
            >
                {showSearchIcon && (
                    <div
                        className=" cursor-pointer flex items-center mr-2 "
                        onClick={onIconClick}
                    >
                        <img
                            src={Search || '/placeholder.svg'}
                            alt="Search Icon"
                            className="w-4 h-4"
                        />
                    </div>
                )}

                <input
                    type={number ? 'number' : 'search'}
                    className={`w-full outline-none h-11 ${
                        disabled ? 'disabled' : ''
                    }  ${className}`}
                    disabled={disabled}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    {...rest}
                />

                {addonRight && (
                    <div className="ml-2 cursor-pointer" onClick={onIconClick}>
                        {addonRight}
                    </div>
                )}
            </div>
        </label>
    )
}

export default AppInput
